module.exports = __webpack_public_path__ + "img/zfcg_09.9d7824da.png";